/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.26/esri/copyright.txt for details.
*/
var E,C;!function(E){E[E.GRAPHIC=0]="GRAPHIC",E[E.LABEL=1]="LABEL",E[E._COUNT=2]="_COUNT"}(E||(E={})),function(E){E[E.USER_SETTING=0]="USER_SETTING",E[E.SCALE_RANGE=1]="SCALE_RANGE",E[E.FILTER=2]="FILTER",E[E.DECONFLICTION=3]="DECONFLICTION",E[E._COUNT=4]="_COUNT"}(C||(C={}));export{C as VisibilityFlag,E as VisibilityGroup};
